import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import NewsletterForm from "@/components/feature/NewsletterForm";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-baseline gap-0.5">
              <span className="font-brand text-3xl text-background-50">{siteConfig.brandMark}</span>
              <span className="font-brand text-3xl text-accent-400">{siteConfig.brandMarkAccent}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85 max-w-sm">
              {siteConfig.description}
            </p>
            <div className="mt-6" id="newsletter">
              <h4 className="text-sm font-medium text-accent-300 mb-3">
                <a href="#newsletter" className="hover:text-accent-200">订阅看点日报</a>
              </h4>
              <NewsletterForm tone="dark" />
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <h4 className="text-sm font-medium text-accent-300 mb-4">
              <Link to="/topics" className="hover:text-accent-200">主题分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/topic/${item.slug}`}
                    className="text-sm text-background-200/85 hover:text-background-50 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-medium text-accent-300 mb-4">
              <Link to="/about" className="hover:text-accent-200">关于与帮助</Link>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/today" className="text-sm text-background-200/85 hover:text-background-50 transition-colors">今日看点</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/85 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="text-sm text-background-200/85 hover:text-background-50 transition-colors">常见问题</Link></li>
              <li><Link to="/contact" className="text-sm text-background-200/85 hover:text-background-50 transition-colors">联系我们</Link></li>
              <li>
                <a href={`mailto:${siteConfig.contactEmail}`} rel="nofollow" className="text-sm text-background-200/85 hover:text-background-50 transition-colors">
                  {siteConfig.contactEmail}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {year} {siteConfig.name} · 内容均为公开信息整理，仅供阅读参考
          </p>
          <p className="text-xs text-background-200/70 flex items-center gap-2">
            <i className="ri-refresh-line"></i>
            {siteConfig.updatedAt}
          </p>
        </div>
      </div>
    </footer>
  );
}